import React from 'react';
import { useTranslation } from 'react-i18next';
import { AgencyLink } from '../AgencyAdditionalInfo/styled';
import { ContactLink, ContactsContainer } from './styled';
import { ScheduleAndLocationBlock } from '../ScheduleAndLocationBlock';
import { ResidenceApartmentsInfo } from '../ResidenceApartmentsInfo';
import { Apartment } from '../../../../graphql/types';
import { OwnerAdditionalInfoWrapper } from '../blocks/OwnerContactsBlock/styled';

interface ResidenceAdditionalInfoProps {
  linkPath: string;
  website?: string;
  contactEmail?: string;
  schedule?: string | null;
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  apartments?: Apartment[];
  priceMin?: number;
  currency?: string;
  deadline?: string;
  hasBillOfSale: boolean;
  hasInternalLoan?: boolean;
  city?: string | null;
}

export const ResidenceAdditionalInfo: React.FC<
  ResidenceAdditionalInfoProps
> = ({
  linkPath,
  website,
  contactEmail,
  schedule,
  address,
  latitude,
  longitude,
  apartments,
  priceMin,
  currency,
  deadline,
  hasBillOfSale,
  hasInternalLoan,
  city
}) => {
  const { t } = useTranslation();

  return (
    <>
      <OwnerAdditionalInfoWrapper>
        <ResidenceApartmentsInfo
          apartments={apartments}
          priceMin={priceMin}
          currency={currency}
          deadline={deadline}
          hasBillOfSale={hasBillOfSale}
          hasInternalLoan={hasInternalLoan}
        />
        <ScheduleAndLocationBlock
          address={address}
          latitude={latitude}
          longitude={longitude}
          schedule={schedule}
          city={city}
          dataStat="residence-address"
        />
      </OwnerAdditionalInfoWrapper>

      <AgencyLink href={linkPath} data-cy="phones-additional__btns-link-btn">
        {t('pages.current_item.go_to_residence')}
      </AgencyLink>

      {(contactEmail || website) && (
        <ContactsContainer>
          {contactEmail && (
            <ContactLink
              href={`mailto:${contactEmail}`}
              data-cy="phones-additional__contacts-link"
            >
              {contactEmail}
            </ContactLink>
          )}
          {website && (
            <ContactLink
              href={website}
              data-cy="phones-additional__contacts-link"
            >
              {website}
            </ContactLink>
          )}
        </ContactsContainer>
      )}
    </>
  );
};
